import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import { fetchHumans, fetchTargets, setCustomerInView} from "../../../../../actions";
import {
    // bbDangerousStringToDate,
    bbDoesUserHaveAccessToModule, bbFormattedDateString, bbGetModulePropertyFromIdOrName,
    isCurrentUserMemberOf, showBBNotification
} from "../../../../../util/bbHelpers";
import TileCountVectorsViableForCustomer
    from "../../../../../components/customBreachBits/metrics/TileCountVectorsPotentiallyBreaching";
import TileRecentlyBreachedLast30Days
    from "../../../../../components/customBreachBits/metrics/TileRecentlyBreachedLast30Days";
import TileCountLifetimeBreaches from "../../../../../components/customBreachBits/metrics/TileCountLifetimeBreaches";
import TileCountLifetimeAttacksDefended
    from "../../../../../components/customBreachBits/metrics/TileCountLifetimeAttacksDefended";
import Tooltip from "@material-ui/core/Tooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import TileCountPhishingAttacksForCustomer
    from "../../../../../components/customBreachBits/metrics/TileCountPhishingAttacksForCustomer";
import TileCountCampaignsViableForCustomer
    from "../../../../../components/customBreachBits/metrics/TileCountCampaignsViableForCustomer";
import TileCountVectorsNotViable
    from "../../../../../components/customBreachBits/metrics/TilePercentVectorQuality";
// import {BBTourDashboard} from "./BBTourDashboard";
import Widget from "../../../../../components/prefabricated/Widget";
import BBIconTutorialArrows from "../../../../../assets/bbCustomIcons/BBIconTutorialArrows";
import TileCountCVEsForCustomerInView
    from "../../../../../components/customBreachBits/metrics/TileCountCVEsForCustomerInView";
import TileRecentlyDefendedLast30Days
    from "../../../../../components/customBreachBits/metrics/TileRecentlyDefendedLast30Days";
import TileCountHighRiskServices from "../../../../../components/customBreachBits/metrics/TileCountHighRiskServices";
import { HashLink as Link } from 'react-router-hash-link';
import YourDashboardBanner from "../../../../../assets/images/Your-Dashboard.svg";
import BBIconSettings from "../../../../../assets/bbCustomIcons/BBIconSettings";
import BBIconInformationUserManual from "../../../../../assets/bbCustomIcons/BBIconInformationUserManual";
import BBIconBellService from "../../../../../assets/bbCustomIcons/BBIconBellService";
import TileInsiderCountAttacksReady
    from "../../../../../components/customBreachBits/metrics/TileInsiderCountAttacksReady";
import TileCountVectorsPotentiallyBreaching
    from "../../../../../components/customBreachBits/metrics/TileCountVectorsPotentiallyBreaching";
import {INFO} from "../../../../../constants/ActionTypes";
import IntlMessages from "../../../../../util/IntlMessages";
import {Col, Row} from "reactstrap";
import UserManualHeaderWidget from "../../../usermanual/UserManualHeaderWidget";
import BBIconFAQQuestionChat from "../../../../../assets/bbCustomIcons/BBIconFAQQuestionChat";
import {Link as ExternalLink} from "@mui/material";
import BBIconKnowledgeBaseBook from "../../../../../assets/bbCustomIcons/BBIconKnowledgeBaseBook";
import {Modal} from "@material-ui/core";
import AlertDialog from "../../../../../components/customBreachBits/modals/PopupAlert";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

const Dashboard= (props) => {

      /*Get state*/
      const {customers, customerInView, loadingTargets, loadingHumans, metaTargets} = useSelector(({customer}) => customer);
    const authUser = useSelector(({auth}) => auth.authUser);
    const isAdminStaff = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");
    // const isCustomer = isCurrentUserMemberOf(authUser, "customer");

    const dispatch = useDispatch();

    // const noCustomerAssociated = (authUser
    //     && authUser.customers
    //     && Array.isArray(authUser.customers)
    //     && authUser.customers.length === 0)
    //     && !isAdminStaff;
    //
    // const userNotVerified = (authUser
    //     && authUser.user
    //     && !authUser.user.is_activated);

    // console.log("user is admin staff", isAdminStaff, "user is  verified", authUser.user.is_activated, "noCustomer", noCustomerAssociated)

    useEffect( () => {
        //console.log("here is customers", customers, "metaTargets", metaTargets);
        if (authUser && authUser.customers && authUser.customers[0] && customerInView === null) {
            const defaultId = authUser.customers[0].customer
            dispatch(setCustomerInView(defaultId));
            // console.log("On the dashboard had to set the customer in view", defaultId, customerInView);
        }
        if (customers && authUser && customerInView && customers[customerInView] && (!customers[customerInView].targets || (metaTargets && !metaTargets[customerInView]))) {
            dispatch(fetchTargets({
                customerId: customerInView
            }));
        }
        if (customers && authUser && customerInView && customers[customerInView] && !customers[customerInView].humans && !loadingHumans) {
            // console.log("humans is empty, fetching humans for customerId = ", customer.CustomerId);
            dispatch(fetchHumans({
                customerId: customerInView
            }));
        }

        if (authUser && !authUser.user.is_activated){
            showBBNotification(INFO,
                <IntlMessages id={"event.userNotApproved.title"}/>,
                <IntlMessages id={"event.userNotApproved.detail"}/>,
                true);
        }

        // console.log("customer in view", customerInView);
    }, [customers, authUser, customerInView, loadingTargets, loadingHumans]);

    // const dateJoined = authUser ? bbDangerousStringToDate(authUser.user.date_joined) : null;
    // const now = Date.now();
    // const daysSinceJoined = (authUser && !!dateJoined) ? Math.floor((now - dateJoined)/1000/60/60/24) : null;
    // const showIntroTour =  (!!daysSinceJoined && daysSinceJoined < 180) || isAdminStaff;

    return (
      <div className="animated fadeIn animation-duration-7 ">
          {/*<BBTourDashboard/>*/}
          <div className="row">
              <div className={"col-8 align-self-center"}>
                  <div className={"mx-0 px-0 pb-3"}>
                      <div style={{backgroundImage: `url(${YourDashboardBanner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>

                  </div>
              </div>
          </div>

        {/*{ (showIntroTour && (isCustomer || isAdminStaff)) &&*/}
          <>
              {/*<div className="row">*/}

              {/*<div className={"col-6"} >*/}
              {/*    <h3>Welcome aboard!</h3>*/}
              {/*    <p><em>It looks like this is your first year with t, so here are a few quick spots to help you get started. Try out a Guided Tour walkthrough!</em></p>*/}
              {/*</div>*/}
              {/*</div>*/}

              <Row>

                  <Col>
                      <Link smooth to={{pathname: "/board/settings/subscription"}}>
                          <UserManualHeaderWidget title={"Settings"}
                                                  subtitle={"Preferences & active services."}
                                                  icon={<BBIconSettings  style={{fontSize: "70px"}}/>}/>
                      </Link>
                  </Col>

                  <Col>
                      <Link smooth to={{pathname: "/board/faq"}}>
                          <UserManualHeaderWidget title={"FAQ"}
                                                  subtitle={"Frequently Asked Questions"}
                                                  icon={<BBIconFAQQuestionChat  style={{fontSize: "70px"}}/>}/>
                      </Link>
                  </Col>
                  <Col>
                      <ExternalLink  target="_blank" rel="noopener" href={"https://support.breachbits.com/knowledge"} className={"text-decoration-none"}>
                          <UserManualHeaderWidget title={"Knowledge Base"}
                                                  subtitle={"More how-to & support"}
                                                  icon={<BBIconKnowledgeBaseBook  style={{fontSize: "70px"}}/>}/>
                      </ExternalLink>
                  </Col>

                  <Col>
                      <Link smooth to={{pathname: "/board/contact"}}>
                          <UserManualHeaderWidget title={"Contact"}
                                                  subtitle={"Feedback, support, and anything else"}
                                                  icon={<BBIconBellService  style={{fontSize: "70px"}}/>}/>
                      </Link>
                  </Col>


              </Row>
              <hr/>
          </>

          {/*{(userNotVerified || noCustomerAssociated)*/}
          {/*    ? <Dialog*/}
          {/*        open={true}*/}
          {/*        aria-labelledby="dialog-title"*/}
          {/*        aria-describedby="dialog-description"*/}
          {/*    >*/}
          {/*        <DialogTitle id="dialog-title" className={"text-center"}>Your Account Is Not Ready</DialogTitle>*/}
          {/*        <DialogContent>*/}
          {/*            <DialogContentText id="dialog-description">*/}
          {/*                {userNotVerified &&*/}
          {/*                    <p>*/}
          {/*                        Please verify your email address. If you need another verification email sent, please contact <a href={"mailto:support@breachbits.com"}>support@breachbits.com</a>*/}
          {/*                    </p>*/}
          {/*                }*/}

          {/*                {noCustomerAssociated &&*/}
          {/*                      <p>*/}
          {/*                          You don't have any companies associated with your account, be sure to <Link to={`/confirmNew`}>confirm your company details.</Link>*/}
          {/*                          {userNotVerified && <em><small> Your email must be verified to complete this step.</small></em> }*/}
          {/*                      </p>*/}
          {/*                }*/}
          {/*            </DialogContentText>*/}
          {/*        </DialogContent>*/}
          {/*        <DialogActions>*/}
          {/*        </DialogActions>*/}
          {/*    </Dialog>*/}
          {/*    : null*/}
          {/*}*/}
          {/*}*/}
        {/*{isAdminStaff && (*/}
        {/*      <>*/}
        {/*          <div className={"tourStepAdminOverviewDashboard"}>*/}
        {/*              <h3>Admin/Staff Overview</h3>*/}
        {/*              <p>Quick stats for staff.</p>*/}
        {/*          </div>*/}
        {/*      <div className="row">*/}
        {/*          <div key={"activeClientsTile"} className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">*/}
        {/*              <ActiveClientsTile />*/}
        {/*          </div>*/}
        {/*          <div key={"activeUsersTile"} className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">*/}
        {/*              <TileCountActiveUsers/>*/}
        {/*          </div>*/}
        {/*          <div key={"allUsersTile"} className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">*/}
        {/*              <TileCountAllUsers/>*/}
        {/*          </div>*/}
        {/*          <div key={"anotherDataTile"} className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">*/}
        {/*              <TileCountCIRTActive/>*/}
        {/*          </div>*/}
        {/*      </div>*/}
        {/*          <hr/>*/}
        {/*      </>*/}
        {/*  )}*/}

              <>
                  <div className={"tourStepQuickOverview"}>
                      <h3>Quick Overview</h3>
                      <p>Highlights from across your services and modules.</p>
                  </div>
              <div className="row tourStepTopStats">

                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6">
                      <Link smooth to={{pathname: "/board/CIRT/external/AttackSurface", hash:"DangerousServicesChart"}}>
                        <TileCountHighRiskServices/>
                      </Link>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6">
                      <Link smooth to={{pathname: "/board/CIRT/external/AttackSurface", hash:"VulnerableTargetsTable"}}>
                        <TileCountCVEsForCustomerInView/>
                      </Link>
                  </div>

                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6">
                      <Link smooth to={isAdminStaff || bbDoesUserHaveAccessToModule(authUser, "perimeter") ? {pathname: "/board/CIRT/external/Vectors", hash:"PerimeterVectorsSection"} : {pathname: bbGetModulePropertyFromIdOrName("perimeter", "breachboardUserGuideUrl"), hash:bbGetModulePropertyFromIdOrName("perimeter", "breachboardUserGuideUrlHash")}}>

                      {/*<TileCountVectorsCampaignsViableForCustomer/>*/}
                          <TileCountVectorsPotentiallyBreaching/>
                      </Link>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6">
                      <Link smooth to={isAdminStaff || bbDoesUserHaveAccessToModule(authUser, "perimeter") ? {pathname: "/board/CIRT/external/Vectors", hash:"PerimeterVectorsSection"} : {pathname: bbGetModulePropertyFromIdOrName("perimeter", "breachboardUserGuideUrl"), hash:bbGetModulePropertyFromIdOrName("perimeter", "breachboardUserGuideUrlHash")}}>
                        <TileCountVectorsNotViable/>
                      </Link>
                  </div>
                  {/*<div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6">*/}
                  {/*    <Link smooth to={{pathname: "/board/CIRT/external/Overview"}}>*/}
                  {/*        <TileIsCIRTActive/>*/}
                  {/*    </Link>*/}
                  {/*</div>*/}
                  {/*<div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6">*/}
                  {/*    <Link smooth to={{pathname: "/board/CIRT/insider"}}>*/}
                  {/*        <TileInsiderCountAttacksPending/>*/}
                  {/*    </Link>*/}
                  {/*</div>*/}
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6">
                      <Link smooth to={isAdminStaff || bbDoesUserHaveAccessToModule(authUser, "social") ? {pathname: "/board/CIRT/external/Vectors", hash:"SocialVectorsSection"} : {pathname: bbGetModulePropertyFromIdOrName("social", "breachboardUserGuideUrl"), hash:bbGetModulePropertyFromIdOrName("social", "breachboardUserGuideUrlHash")}}>
                          <TileCountPhishingAttacksForCustomer/>
                      </Link>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6">
                      <Link smooth to={isAdminStaff || bbDoesUserHaveAccessToModule(authUser, "insider") ? {pathname: bbGetModulePropertyFromIdOrName("insider", "breachboardUrl")} : {pathname: bbGetModulePropertyFromIdOrName("insider", "breachboardUserGuideUrl"), hash:bbGetModulePropertyFromIdOrName("insider", "breachboardUserGuideUrlHash")}}>
                          <TileInsiderCountAttacksReady/>
                      </Link>
                  </div>

              </div>
              <hr/>
              <div className={"tourStepDefenderScoreboard"}>
                  <h3>Defender Scoreboard <Tooltip title={"It's war.  Here is how you're holding up."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                  <p>By subscribing to the {"{CIRT}"} continuous red team service, your company is demonstrating an advanced level of care for your data and your critical business functions. Here are a few stats for your scoreboard. Congratulations!</p>
              </div>
              <div className="row">
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
                      <Link smooth to={isAdminStaff || bbDoesUserHaveAccessToModule(authUser, "perimeter") ? {pathname: "/board/CIRT/external/Overview", hash:"BreachesTable"} : {pathname: bbGetModulePropertyFromIdOrName("perimeter", "breachboardUserGuideUrl"), hash:bbGetModulePropertyFromIdOrName("perimeter", "breachboardUserGuideUrlHash")}}>
                        <TileCountLifetimeBreaches/>
                      </Link>
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
                      <Link smooth to={isAdminStaff || bbDoesUserHaveAccessToModule(authUser, "perimeter") ? {pathname: "/board/CIRT/external/Vectors"} : {pathname: bbGetModulePropertyFromIdOrName("perimeter", "breachboardUserGuideUrl"), hash:bbGetModulePropertyFromIdOrName("perimeter", "breachboardUserGuideUrlHash")}}>
                        <TileCountLifetimeAttacksDefended/>
                      </Link>
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
                      <Link smooth to={isAdminStaff || bbDoesUserHaveAccessToModule(authUser, "perimeter") ? {pathname: "/board/CIRT/external/Overview", hash:"BreachesTable"} : {pathname: bbGetModulePropertyFromIdOrName("perimeter", "breachboardUserGuideUrl"), hash:bbGetModulePropertyFromIdOrName("perimeter", "breachboardUserGuideUrlHash")}}>
                        <TileRecentlyBreachedLast30Days/>
                      </Link>
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
                      <Link smooth to={isAdminStaff || bbDoesUserHaveAccessToModule(authUser, "perimeter") ? {pathname: "/board/CIRT/external/Vectors"} : {pathname: bbGetModulePropertyFromIdOrName("perimeter", "breachboardUserGuideUrl"), hash:bbGetModulePropertyFromIdOrName("perimeter", "breachboardUserGuideUrlHash")}}>
                        <TileRecentlyDefendedLast30Days/>
                      </Link>
                  </div>
              </div>
              <div className="row">
                                    <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6">
                                        <Link smooth to={isAdminStaff || bbDoesUserHaveAccessToModule(authUser, "perimeter") ? {pathname: "/board/CIRT/external/Vectors", hash:"PerimeterVectorsSection"} : {pathname: bbGetModulePropertyFromIdOrName("perimeter", "breachboardUserGuideUrl"), hash:bbGetModulePropertyFromIdOrName("perimeter", "breachboardUserGuideUrlHash")}}>

                                        <TileCountVectorsViableForCustomer/>
                                        </Link>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6">
                          <Link smooth to={isAdminStaff || bbDoesUserHaveAccessToModule(authUser, "social") ? {pathname: "/board/CIRT/external/Vectors", hash:"SocialVectorsSection"} : {pathname: bbGetModulePropertyFromIdOrName("social", "breachboardUserGuideUrl"), hash:bbGetModulePropertyFromIdOrName("social", "breachboardUserGuideUrlHash")}}>

                          <TileCountCampaignsViableForCustomer/>
                      </Link>

                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6">
                      <Link smooth to={isAdminStaff || bbDoesUserHaveAccessToModule(authUser, "social") ? {pathname: "/board/CIRT/external/Vectors", hash:"SocialVectorsSection"} : {pathname: bbGetModulePropertyFromIdOrName("social", "breachboardUserGuideUrl"), hash:bbGetModulePropertyFromIdOrName("social", "breachboardUserGuideUrlHash")}}>
                          <TileCountPhishingAttacksForCustomer/>
                      </Link>

                  </div>
              </div>
              </>

      </div>
    )

}

export default Dashboard;